import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReportRoutes from './routes'
import { BackTop } from 'antd'
import DataHeader from '../../components/reports/DataHeader'
import history from '../../history'

const propTypes = {}

class ReportsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailShowing: true,
      selectedUser: null,
      currentPage: 'general/activity-report'
    }
  }

  handleClickMenu = e => {
    this.setState({
      currentPage: e.key
    })
    history.push(`/reports/${e.key}`)
  }

  toggleDetails = () => {
    this.setState({
      detailShowing: !this.state.detailShowing
    })
  }

  render() {
    return (
      <div>
        <BackTop />
        <DataHeader
          handleClickMenu={this.handleClickMenu}
          currentKey={this.state.currentKey}
          currentPage={this.state.currentPage}
          screenWidth={this.state.screenWidth}
        />
        <div className="dataPanel">
          <div className="wrapPanel">
            <ReportRoutes selectedUser={this.state.selectedUser} />
            &copy; G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ authentication }, ownProps) => ({
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}), dispatch)
})

ReportsContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportsContainer))



// WEBPACK FOOTER //
// ./src/containers/reports/ReportsContainer.js